<div class="btn-group btn-container" role="group" aria-label="Basic example">
  @if (!disableNav) {
<button
    class="btn btn-custom"
    (click)="navigate('left')"
    ngbTooltip="Previous"
    placement="top"
    >
    <i class="fa fa-angle-left" aria-hidden="true"></i>
  </button>
}
  <button
    class="btn btn-custom btn-date"
    #dateTip="ngbTooltip"
    (click)="dateTip.close(); togglePicker()"
    [ngbTooltip]="singleDay ? 'Select Date' : 'Select Datetime'"
    [disableTooltip]="showPicker"
    placement="top"
    triggers="hover"
    container="body"
    >
    <i class="fa" [ngClass]="singleDay ? 'fa-calendar' : 'fa-clock-o'" aria-hidden="true"></i>&nbsp;
    @if (displayText==='Custom' || displayText==='Event Time' || navigating) {
<span>
      @if (singleDay) {
<span>
        @if (timeSelection) {
<span>{{$safeNavigationMigration(displayDates?.start) | date:'MMM d, h:mm a'}}</span>
}
        @if (!timeSelection) {
<span>{{$safeNavigationMigration(displayDates?.start) | date:'MMM d, yyyy'}}</span>
}
      </span>
}
      @if (!singleDay && timeSelection) {
<span>
        {{$safeNavigationMigration(displayDates?.start) | date:'MMM d, h:mm a'}} -
        {{$safeNavigationMigration(displayDates?.end) | date:'MMM d, h:mm a'}}
      </span>
}
      @if (!singleDay && !timeSelection) {
<span>
        {{$safeNavigationMigration(displayDates?.start) | date:'MMM dd yyyy'}} -
        {{$safeNavigationMigration(displayDates?.end) | date:'MMM dd yyyy'}}
      </span>
}
    </span>
}
    @if (displayText!=='Custom' && displayText!=='Event Time' && !navigating) {
<span>
      {{displayText}}
    </span>
}
  </button>
  @if (!disableNav) {
<button
    class="btn btn-custom"
    (click)="navigate('right')"
    ngbTooltip="Next"
    placement="top"
    [disabled]="disableNavigation"
    >
    <i class="fa fa-angle-right" aria-hidden="true"></i>
  </button>
}
</div>

@if (showPicker) {
<div
  class="calendar-overlay"
  [class.calendar-overlay--day]="singleDay || hideQuickLinks"
  [class.calendar-overlay--single-month]="displayMonths === 1"
  >
  <div class="calendar" [class.calendar--solo]="hideQuickLinks">
    <ngb-datepicker
      [startDate]="{year: $safeNavigationMigration(fromDate?.year), month: $safeNavigationMigration(fromDate?.month)}"
      [maxDate]="maxDate" #dp
      (dateSelect)="onDateSelection($event)"
      (navigate)="navigationOnMonth($event)"
      [displayMonths]="displayMonths"
      [navigation]="'arrows'"
      [showWeekNumbers]="false"
      [dayTemplate]="t"
      [dayTemplateData]="dayTemplateData"
      outsideDays="hidden"
      >
    </ngb-datepicker>
    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day {{getEventClass(date)}}"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
        >
        {{ date.day }}
        @if (getRangeMinMax(date)) {
<img class="loading" src="../../../assets/img/loading.gif"/>
}
      </span>
    </ng-template>

    @if (timeSelection) {
<div class="time-picker d-block text-left mt-3">
      <div class="from-time d-inline-block mr-4 pl-2">
        <span class="title text-dark-grey bold">From:&nbsp;
          <span class="bold text-blue-grey">
            {{fromDate?.day}}/{{fromDate?.month}}/{{fromDate?.year}}
          </span>
        </span>
        <ngb-timepicker [(ngModel)]="fromtime" [meridian]="meridian"></ngb-timepicker>
      </div>
      <div class="to-time d-inline-block ml-3">
        <span class="title text-dark-grey bold">To:&nbsp;
          @if (toDate==null) {
<span class="bold text-blue-grey">
            {{fromDate?.day}}/{{fromDate?.month}}/{{fromDate?.year}}
          </span>
}
          @if (toDate!=null) {
<span class="bold text-blue-grey">
            {{toDate?.day}}/{{toDate?.month}}/{{toDate?.year}}
          </span>
}
        </span>
        <ngb-timepicker [(ngModel)]="totime" [meridian]="meridian"></ngb-timepicker>
      </div>
    </div>
}
    @if (!autoApply) {
    <div class="d-block text-right" [class.mt-2]="!timeSelection">
      @if (invalidDateTime) {
<small class="text-danger pr-4">{{errorText}}</small>
}
      <button class="btn btn-outline-secondary width100px mr-2" (click)="closePicker()">Cancel</button>
      <button class="btn btn-primary width100px" (click)="setCustomDate()">Apply</button>
    </div>
}
  </div>
  @if (!hideQuickLinks) {
  <span class="pre-sets"><b>Quick Selection</b></span>
  <div class="quick-links" [class.noTimeHeight]="!timeSelection">
    <ul>
      <li [class.selected]="displayText=='Custom'">
        Custom
      </li>
      @if (!hideLinks.includes('today')) {
<li
        [class.selected]="displayText=='Today'"
       
        (click)="onTimeChange('today')"
        >Today
      </li>
}
      @if (!hideLinks.includes('15mins')) {
<li
        [class.selected]="displayText=='Last 15 Minutes'"
       
        (click)="onTimeChange('15mins')"
        >Last 15 minutes
      </li>
}
      @if (!hideLinks.includes('30mins')) {
<li
        [class.selected]="displayText=='Last 30 Minutes'"
       
        (click)="onTimeChange('30mins')"
        >Last 30 minutes
      </li>
}
      @if (!hideLinks.includes('1hour')) {
<li
        [class.selected]="displayText=='Last 1 Hour'"
       
        (click)="onTimeChange('1hour')"
        >Last 1 hour
      </li>
}
      @if (!hideLinks.includes('4hours')) {
<li
        [class.selected]="displayText=='Last 4 Hours'"
       
        (click)="onTimeChange('4hours')"
        >Last 4 hours
      </li>
}
      @if (!hideLinks.includes('12hours')) {
<li
        [class.selected]="displayText=='Last 12 Hours'"
       
        (click)="onTimeChange('12hours')"
        >Last 12 hours
      </li>
}
      @if (!hideLinks.includes('24hours')) {
<li
        [class.selected]="displayText=='Last 24 Hours'"
       
        (click)="onTimeChange('24hours')"
        >Last 24 hours
      </li>
}
      @if (!hideLinks.includes('7days')) {
<li
        [class.selected]="displayText=='Last 7 Days'"
       
        (click)="onTimeChange('7days')"
        >Last 7 days
      </li>
}
      @if (!hideLinks.includes('30days')) {
<li
        [class.selected]="displayText=='Last 30 Days'"
       
        (click)="onTimeChange('30days')"
        >Last 30 days
      </li>
}
      @if (!hideLinks.includes('week')) {
<li
        [class.selected]="displayText=='This Week'"
       
        (click)="onTimeChange('week')"
        >This week
      </li>
}
      @if (!hideLinks.includes('month')) {
<li
        [class.selected]="displayText=='This Month'"
       
        (click)="onTimeChange('month')"
        >This month
      </li>
}
      @if (!hideLinks.includes('todaysofar')) {
<li
        [class.selected]="displayText=='Today so Far'"
       
        (click)="onTimeChange('todaysofar')"
        >Today so far
      </li>
}
      @if (!hideLinks.includes('weektodate')) {
<li
        [class.selected]="displayText=='Week to Date'"
       
        (click)="onTimeChange('weektodate')"
        >Week to date
      </li>
}
      @if (!hideLinks.includes('monthtodate')) {
<li
        [class.selected]="displayText=='Month to Date'"
       
        (click)="onTimeChange('monthtodate')"
        >Month to date
      </li>
}
      @if (!hideLinks.includes('90days')) {
<li
        [class.selected]="displayText=='Last 90 days'"
       
        (click)="onTimeChange('90days')"
        >Last 90 days
      </li>
}
      @if (!hideLinks.includes('180days')) {
<li
        [class.selected]="displayText=='Last 180 days'"
       
        (click)="onTimeChange('180days')"
        >Last 180 days
      </li>
}
      @if (!hideLinks.includes('365days')) {
<li
        [class.selected]="displayText=='Last 365 days'"
       
        (click)="onTimeChange('365days')"
        >Last 365 days
      </li>
}
    </ul>
  </div>
}
</div>
}
